import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import VueScrollTo from 'vue-scrollto';
import Public from './views/Public.vue';

Vue.use(Router);
Vue.use(VueScrollTo, {
  duration: 1000,
  easing: [0.77, 0, 0.175, 1],
  onStart: () => {
    store.commit('setScroll', true);
  },
  onDone: () => {
    store.commit('setScroll', false);
  },
  onCancel: () => {
    store.commit('setScroll', false);
  },
});

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    if (to.hash && to.query.scroll) {
      VueScrollTo.scrollTo(to.hash);
    }
  }
  return false;
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'public',
      component: Public,
    },
  ],
});
